export const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: 'white'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1em',
    width: 'auto'
  },
  button: {
    marginTop: '2em',
    textAlign: 'center'
  },
  link: {
    textDecoration: 'none'
  }
}



// WEBPACK FOOTER //
// ./src/pages/UpdateEmail/styles.js